import Card from "@/components/card"
import { useAppSelector } from "@/core/root-reducer"
import { useRisksSpace } from "@/core/risks-space.context"
import preventionActionStore from "@/entities/prevention-action/model/prevention-action.store"
import PreventionActionsChecklist from "@/entities/prevention-action/ui/PreventionActionsChecklist"
import PreventionActionAddModal from "@/entities/prevention-action/ui/modal/PreventionActionAddModal"
import { useState } from "react"
import { Population } from "../model/population.types"
import { RpsRiskAxis } from "../model/rps-risk"
import RpsRiskCell, { RPS_GLOBAL_CELL_WIDTH } from "./RpsRiskCell"
import RpsSituationsList from "./RpsSituationsList"
import RpsRiskEditModal from "./modal/RpsRiskEditModal"
import RpsEvaluationEditModal from "./modal/RpsEvaluationEditModal"

export default function PopulationRpsCard({ population }: { population: Population }) {
  const { isReadonly } = useRisksSpace()
  const [editingAxis, setEditingAxis] = useState<RpsRiskAxis | null>(null)
  const [isAddingMeasure, setIsAddingMeasure] = useState(false)
  const [editingEvaluation, setEditingEvaluation] = useState(false)
  //Mesures RPS de la fonction, et celles de tout l'etablissement
  const measures = useAppSelector((state) => preventionActionStore.selectors.listRps(state, population.id))

  return (
    <Card className="mt-[16px]" style={{ padding: 24 }}>
      {editingAxis && <RpsRiskEditModal population={population} axis={editingAxis} onClose={() => setEditingAxis(null)} />}
      {isAddingMeasure && (
        <PreventionActionAddModal rpsPopulationIds={[population.id]} onClose={() => setIsAddingMeasure(false)} />
      )}
      {editingEvaluation && <RpsEvaluationEditModal population={population} onClose={() => setEditingEvaluation(false)} />}
      <div className="flex items-start justify-between gap-[16px] pb-[12px]">
        <h3 className="text-base font-bold" style={{ margin: 0 }}>Niveau de risque</h3>
        <div className="shrink-0" style={{ width: RPS_GLOBAL_CELL_WIDTH }}>
          <RpsRiskCell level={population.cRpsLevel} isGlobal label="Niveau de risque" onClick={() => setEditingEvaluation(true)} />
        </div>
      </div>
      <RpsSituationsList population={population} onAxisClick={isReadonly ? undefined : setEditingAxis} />

      <div className="mt-[24px]">
        <h3 className="text-base font-bold mb-[16px]">Mesures de prévention</h3>
        <PreventionActionsChecklist
          isReadonly={isReadonly}
          preventionActions={measures}
          onAdd={() => setIsAddingMeasure(true)}
        />
      </div>
    </Card>
  )
}
